<template>
  <div class="section bottom-background">
    <div class="content-bg">
      <!-- <div class="container">
        <img class="content-img" :src="data.imgLeft" alt="二维码" />
        <p class="content-text">{{data.textLeft}}</p>
      </div>
      <div class="container">
        <img class="content-img" :src="data.imgRight" alt="二维码" />
        <p class="content-text">{{data.textRight}}</p>
      </div>
      <div class="content-wrapper">
        <p class="qr-gzh">{{data.qrGongzhonghao}}</p>
        <p class="qr-gzh">{{data.qrText}}</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import VueTypes from 'vue-types'

export default {
  props: {
    data: VueTypes.object.def({})
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState(['isMobile']),
  }
}
</script>

<style lang="scss" scoped>

.bottom-background {
  width: 100%;
  background: #1B3153;
}

.content-bg {
  display: flex; align-items: center; justify-content: center;
  width: 100%;
  padding: 43px 28px 47px;

  @include mobile {
    padding: 43px 20px 47px;
  }
}

.container {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  margin-right: 80px;

  @include mobile {
    margin-right: 25px;
  }
}

.content-img {
  width: 140px; height: 140px;
  // margin-right: 80px;

  @include mobile {
    width: 70px; height: 70px;
    // margin-right: 26px;
  }
}

.content-text {
  margin-top: 16px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 21px;

  @include mobile {
    font-size: 10px;
    line-height: 14px;
  }
}

.content-wrapper {
  margin-left: 50px;

  @include mobile {
    margin-left: 0;
  }
}

.qr-gzh {
  font-size: 22px;
  font-family: Alibaba-PuHuiTi-Heavy;
  color: #FFFFFF;
  line-height: 40px;

  @include mobile {
    font-size: 13px;
    line-height: 22px;
  }
}

// .qr-text {
//   font-size: 15px; font-weight: 400;
//   color: #FFFFFF;
//   line-height: 21px;
//   letter-spacing: 6px;

//   @include mobile {
//     font-size: 13px;
//     line-height: 18px;
//     letter-spacing: 5px;
//   }
// }
</style>
